var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKanziLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logos",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Kanzi_logo_Black") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.56,19.69l8.57-7.82h8.72L19.95,22.15l13.21,10.5H23.87l-9.31-7.91H11.32v7.91H5V11.88h6.32v7.82Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.06,32.65H35L46.61,11.88h8.53L66.48,32.65h-7l-2-3.77H44.12Zm4.27-8.07h8.91l-4.45-8.22Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87.78,32.65,75.26,17v15.6H69.31V11.88H79.37L91.89,27.45V11.88h5.95V32.65Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M127.58,27.95v4.7H102.32v-4.7L118,16.61H102.73V11.88h24.54v4.73L111.48,27.95Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M132.06,32.65V11.88h6.32V32.65Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M142.86,7.35A2.14,2.14,0,1,0,145,9.49,2.14,2.14,0,0,0,142.86,7.35Zm0,4a1.81,1.81,0,1,1,1.81-1.81A1.82,1.82,0,0,1,142.86,11.31Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M143.36,10.42a0,0,0,0,1,0,0l-.38-.77h-.34a0,0,0,0,0,0,0v.75a0,0,0,0,1,0,0h-.28a0,0,0,0,1,0,0V8.48a0,0,0,0,1,0,0H143a.59.59,0,0,1,.63.59.56.56,0,0,1-.37.54l.42.8a0,0,0,0,1,0,0Zm0-1.38a.28.28,0,0,0-.3-.28h-.42a0,0,0,0,0,0,0V9.3a0,0,0,0,0,0,0H143A.27.27,0,0,0,143.32,9Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKanziLogo);
export default __webpack_public_path__ + "static/media/kanzi_logo.d287ca16845e84a2c551f7a73ff7cdb9.svg";
export { ForwardRef as ReactComponent };